import { render } from "./LoginOrRegister.vue?vue&type=template&id=eaf318e6&ts=true"
import script from "./LoginOrRegister.vue?vue&type=script&lang=ts"
export * from "./LoginOrRegister.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__